export default {
    name: 'vue-sidebar',
    props: ['facets', 'value'],
    delimiters: ['$[', ']'], 
    template: `
      <div class="collection__sidebar">
			
			<div class="searchbox">
			  <input class="searchbox" placeholder="Search.." type="text" v-bind:value="value" v-on:input="updateValue($event.target.value)">
			</div>

            <div class="priceSliderFacet">
              <div class="filter-item price-range">
              	<div id="price-range"></div>
				
				<div class="price-range-values">
					<span id="price-min" class='money2'>$[minRange] AED</span>
					<span id="price-max" class='money2'>$[maxRange] AED</span>
				</div>
              </div>
            </div>

       		<div v-for="facet in facets" :key="facet.attribute" v-if="checkFacetType(facet.attribute)" class="facet">
              <div class="snize-product-filters-title" v-on:click="collaps[facet.attribute] = !collaps[facet.attribute]">
                  $[ facet.title  ] 

				  <span v-if="collaps[facet.attribute]" class="arrow" v-bind:class="{ open: !collaps[facet.attribute] }">+</span>
				  <span v-if="!collaps[facet.attribute]" class="arrow" v-bind:class="{ open: !collaps[facet.attribute] }">-</span>
              </div>
              <ul class="snize-product-filters-list collapsible" v-show="!collaps[facet.attribute]">
                 <div class="itemList" v-for="(item, index) in facet.buckets" :key="item.value">
                    <div class="filter-item">
						<input :disabled="item.count == 0" @click="checkSelected(item, facet.attribute)" type="checkbox" 
                            class="radio" v-bind:id=" 'item-' + facet.attribute + index" 
                              :value="item.value" :name="facet.attribute + '-' + item.value"
                              v-model='facetSelections[facet.attribute]'>
                        <label :disabled="item.count == 0" v-bind:for=" 'item-' + facet.attribute + index">$[item.value ] ($[item.count])</label>
                    </div> 
                 </div>
              </ul>
			</div>
      </div>
    `,

    data: function () {
      return {
        priceSlider: document.getElementById('price-range'),
        collaps: {
          collections: true,
          vendor: true,
          product_type: false,
          tags: false,
          price: false,
          snize_facet2: false
        },
        facetSelections: {
          collections: [],
          vendor: [],
          product_type: [],
          tags: [],
          price: [],
          snize_facet2: []
        },
        minRange: null,
        maxRange: null,
      }
    },

    created: function () {
      let vm = this;
      let searchParams = vm.$parent.store.searchParams;

      if (searchParams.has('product_type') == true) {
        var param = searchParams.get('product_type');
        vm.facetSelections.product_type.push(param);
      }

      if (searchParams.has('tags') == true) {
        var param = searchParams.get('tags');
        vm.facetSelections.tags.push(param);
      }

      if (searchParams.has('collections') == true) {
        var param = searchParams.get('collections');
        vm.facetSelections.collections.push(param);
      }
      
      if (searchParams.has('vendor') == true) {
        var param = searchParams.get('vendor');
        vm.facetSelections.vendor.push(param);
      }
    },

    mounted: function () {
      let vm = this;
      vm.priceSlider = document.getElementById('price-range')
      
      noUiSlider.create(vm.priceSlider, {
        start: [0, 100],
        connect: true,
        tooltips: false,
        range: {
          'min': 0,
          'max': 100
        },
        format: {
          to: function ( value ) {
            return value.toFixed(2);
          },
          from: function ( value ) {
            return value;
          }
        }
      });
      
      

    },

    beforeDestroy: function () {
	  let vm = this;
      vm.priceSlider.noUiSlider.destroy();
    },
  	
    computed: {
      
   
      
      checkPriceFacet() {
        var vm = this;
        var query_params = vm.$parent.query_params;
        var result = false;
        
        if (vm.facets.length > 0) {
          vm.facets.filter(function(item) {
            if (item.attribute == 'price') {
              
              var from = Math.floor(item.buckets[0].from);
              var to = Math.ceil(item.buckets[0].to);
              vm.priceSlider.noUiSlider.destroy();
              
              if (from === to) {
                to = to + 1;
              }
              
              noUiSlider.create(vm.priceSlider, {
                start: [from, to],
                connect: true,
                tooltips: false,
                range: {
                  'min': from,
                  'max': to
                },
                format: {
                  to: function ( value ) {
                    return value.toFixed(2);
                  },
                  from: function ( value ) {
                    return value;
                  }
                }
              });
              
              vm.priceSlider.noUiSlider.on('change.one', vm.updatePrice);
              vm.priceSlider.noUiSlider.on('update', function( values, handle ) {
                //         nonLinearSliderValueElement.innerHTML = values[handle];
//                 console.log(values[handle]);
//                 price-min
//                 price-max
//                 vm[handle ? 'maxRange' : 'minRange'] = parseInt(values[handle]);
                vm[handle ? 'maxRange' : 'minRange'] = values[handle];

                
              });
              
              if (query_params['restrictBy[price]'] != "" ) {
                vm.priceSlider.noUiSlider.set([Math.floor(item.buckets[0].left), Math.ceil(item.buckets[0].right)]);
              }
              
              if (item.buckets[0].from == item.buckets[0].to) {
                vm.priceSlider.setAttribute('disabled', true);
              } else {
                vm.priceSlider.removeAttribute('disabled');
              }


              result = item
              
            }
          });
        }
        
        return result;
      },    
    },
	
    methods: {
      checkFacetType(type) {

        if (type == 'price' || type == 'reviews_average_score_titles') {
          return false;
        } else {
          return true;
        }
      },
      
      checkSelected: function(data, facet) {
        let vm = this;
		let query_params = vm.$parent.query_params;
        
        query_params['restrictBy[price]'] = '';
        query_params.rb_price = '';
        
        if (vm.facetSelections[facet].length > 0) {
          vm.facetSelections[facet] = [];
          vm.facetSelections[facet][0] = data.value;
        }

      },

      updatePrice( values, handle, unencoded, tap, positions ) {
        let vm = this;
        let searchParams = vm.$parent.store.searchParams,
            query_params = vm.$parent.query_params,
            from = unencoded[0],
            to = unencoded[1]
        
        var new_price = from + ',' + to;

        query_params['restrictBy[price]'] = new_price;
        query_params.rb_price = new_price;

      },
      
      updateValue: function (value) {
      	this.$emit('input', value);
      },
      
      updateSlider() {
      }
      
    },

    watch: {
      // whenever question changes, this function will run
      checkPriceFacet: function (newVal, oldVal) {
        console.log("Old :" + oldVal);
        console.log("New :" + newVal);
        window.scrollTo(0, 0);
      },
      
      facetSelections: {
        
        // When the internal value changes, we $emit an event. Because this event is 
        // named 'input', v-model will automatically update the parent value
        handler(val, oldVal) {
          console.log(val);
          let vm = this,
          	  dataCollection,
              dataVendor,
              dataProductType,
              dataTags,
              dataCategories;
          let searchParams = this.$parent.store.searchParams,
              query_params = this.$parent.query_params;

          	  	
          
          if (searchParams.has('page')) {
            searchParams.set('page', 1)
            query_params.page = 1;
            query_params.startIndex = 0;
          }
          
          
          if (val.collections.length > 0) {
            dataCollection = {
              value: val.collections,
              type: "collection"
            }
          } 
          
          if (val.vendor.length > 0) {
            dataVendor = {
              value: val.vendor,
              type: "vendor"
            }
            
            searchParams.set('vendor', dataVendor.value)
            query_params['restrictBy[vendor]'] = dataVendor.value;
            var newPath = window.location.pathname + '?' + searchParams;
            window.history.replaceState({}, '', newPath);
          } else {
            searchParams.delete('vendor')
            query_params['restrictBy[vendor]'] = '';
            var newPath = window.location.pathname + '?' + searchParams;
            window.history.replaceState({}, '', newPath);  
          }
          
          if (val.product_type.length > 0) {
            dataProductType = {
              value: val.product_type[0],
              type: "product_type"
            }
            
            searchParams.set('product_type', dataProductType.value)
            query_params['restrictBy[product_type]'] = dataProductType.value;
            query_params.rb_product_type = dataProductType.value;
            var newPath = window.location.pathname + '?' + searchParams;
            window.history.replaceState({}, '', newPath);
          } else {
            searchParams.delete('product_type')
            query_params['restrictBy[product_type]'] = '';
            query_params.rb_product_type = '';
            
            var newPath = window.location.pathname + '?' + searchParams;
            window.history.replaceState({}, '', newPath);  
          }
          
          if (val.tags.length > 0) {
            dataTags = {
              value: val.tags[0],
              type: "tags"
            }
            
            searchParams.set('tags', dataTags.value)
            query_params['restrictBy[tags]'] = dataTags.value;
            var newPath = window.location.pathname + '?' + searchParams;
            window.history.replaceState({}, '', newPath);
          } else {
            searchParams.delete('tags')
            query_params['restrictBy[tags]'] = '';
            var newPath = window.location.pathname + '?' + searchParams;
            window.history.replaceState({}, '', newPath);  
          }
          
          
          
          if (val.snize_facet2 .length > 0) {
            dataCategories = {
              value: val.snize_facet2[0],
              type: "snize_facet2"
            }
            
            searchParams.set('snize_facet2', dataCategories.value)
            query_params["restrictBy[snize_facet2]"] = dataCategories.value
            query_params.rb_snize_facet2 = dataCategories.value;
            
            var newPath = window.location.pathname + '?' + searchParams;
            window.history.replaceState({}, '', newPath);
          } else {
            searchParams.delete('snize_facet2')
            
            query_params["restrictBy[snize_facet2]"] = ''
            query_params.rb_snize_facet2 = '';
            
            var newPath = window.location.pathname + '?' + searchParams;
            window.history.replaceState({}, '', newPath);  
          }


        },
        deep: true
      }
      
    },
};


